<script setup>
// NOOVI: item de resultado de busca para Follow-up (Gap FU-B — fase-11).
import { computed } from 'vue';
import { frontendURL } from 'dashboard/helper/URLHelper';
import { dynamicTime } from 'shared/helpers/timeHelper';

import CardLayout from 'dashboard/components-next/CardLayout.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  status: {
    type: String,
    default: '',
  },
  contactName: {
    type: String,
    default: '',
  },
  accountId: {
    type: [String, Number],
    default: 0,
  },
  createdAt: {
    type: [String, Number],
    default: 0,
  },
});

const navigateTo = computed(() => {
  return frontendURL(`accounts/${props.accountId}/follow-ups`);
});

const createdAtTime = computed(() => {
  if (!props.createdAt) return '';
  return dynamicTime(props.createdAt);
});

const statusLabel = computed(() => {
  if (!props.status) return '';
  return props.status.charAt(0).toUpperCase() + props.status.slice(1);
});
</script>

<template>
  <router-link :to="navigateTo">
    <CardLayout
      layout="row"
      class="[&>div]:justify-start [&>div]:px-4 [&>div]:py-3 [&>div]:items-start hover:bg-n-slate-2 dark:hover:bg-n-solid-3"
    >
      <Icon
        icon="i-lucide-calendar-clock"
        class="mt-1 flex-shrink-0 text-n-slate-11 size-5"
      />
      <div class="min-w-0 flex flex-col items-start gap-1.5 w-full">
        <div class="flex items-center min-w-0 justify-between gap-2 w-full">
          <h5 class="text-sm font-medium truncate min-w-0 text-n-slate-12 py-1">
            {{ title }}
          </h5>
          <span
            v-if="createdAtTime"
            class="text-sm font-normal min-w-0 truncate text-n-slate-11"
          >
            {{ $t('SEARCH.UPDATED_AT', { time: createdAtTime }) }}
          </span>
        </div>
        <div class="flex items-center gap-3 m-0 text-sm min-w-0">
          <span v-if="statusLabel" class="truncate text-n-slate-11 min-w-0">
            {{ statusLabel }}
          </span>
          <div
            v-if="statusLabel && contactName"
            class="w-px h-3 bg-n-slate-6 rounded"
          />
          <span v-if="contactName" class="truncate text-n-slate-11 min-w-0">
            {{ contactName }}
          </span>
        </div>
      </div>
    </CardLayout>
  </router-link>
</template>
